import { IndustryConfig } from './industry-config.interface';
import { IndustryType } from './industry-types.enum';

/**
 * Restaurant Industry Configuration
 * Uses category-grid UI with image product tiles.
 * Shares the same API endpoints as Retail (no path segment transformation).
 */
export const RestaurantIndustryConfig: IndustryConfig = {
    industryType: IndustryType.RESTAURANT,
    name: 'Restaurant',
    apiPathSegment: null, // Restaurant uses base API paths (same as Retail)
    features: {
        enableFreeQuantity: false,
        enableMapping: false,
        enableVariants: false,
        enableTableManagement: false, // Can be enabled per deployment if table mgmt is needed
        enableKitchenDisplay: false,
        productSearchFields: [],
        orderPlacementFields: [],
    },
};
